<template>
  <div>

    <!-- Search -->
    <div class="row mt-4">
      <div class="col-md-8">
        <input class="input form-control" @keypress.enter="find()" v-model="query.generic"
          placeholder="Find by searchable">
        <search-icon @click="find()" class="icon icon-within" />
      </div>

      <button class="col-md-2 ml-2 btn-sm btn-outline" :class="{ 'btn-outline-active': showFilter }"
        @click="showFilter = !showFilter">
        Filtros
        <chevron-down-icon class="fa-angle-right" :class="{ 'rotate-90': showFilter }" />
      </button>

      <button v-if="changeQueryAndHasNumberOfBadges" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>

    <!-- Badges -->
    <div class="row">
      <div class="col-md-12">
        <BadgeFilters :query="query" @clearBadge="find()" @clearAllBadges="find()"
          :amount-changed="updateNumberOfBadges" :filters="badgeFilters" />
      </div>
    </div>

    <!-- Filters -->
    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-6">
          <label>Account</label>
          <Select2 :options="filterAccount" v-model="query.accountId" title-load="Carregando contas..." />
        </div>

        <div class="col-md-6">
          <label>Kind</label>
          <Select2 :options="filterKind" v-model="query.kind" />
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-4">
          <label for="type-period">Tipo do período</label>
          <select v-model="query.periodType" id="type-period" class="browser-default custom-select">
            <option value="updated_at">Data de atualização</option>
            <option value="created_at">Data de criação</option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="consult-day">Data inicial</label>
          <input v-model="query.startDate" type="date" id="consult-day" class="form-control">
        </div>

        <div class="col-md-4">
          <label for="end-date">Data final</label>
          <input v-model="query.endDate" type="date" id="end-date" class="form-control">
        </div>
      </div>
    </template>
    <hr>

    <!-- Info -->
    <div class="row mt-4">
      <div class="col-md-12">
        <small>
          {{ infoTotalModels }}
        </small>

        <div class="float-right" style="display: inline-flex;align-items: center;">
          <small class="mr-2" style="white-space: nowrap">Ordenar por:</small>
          <select v-model="orderBy" class="browser-default custom-select">
            <option value="created_at">Data de criação</option>
            <option value="updated_at">Data de atualização</option>
            <option value="name">Nome</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="row flex-fill d-flex justify-content-start">
      <div class="col-md-12 mt-2">
        <table class="table table-borderless table-dfe">
          <thead>
            <tr>
              <th>ID</th>
              <th>Account</th>
              <th>Kind</th>
              <th>Version</th>
              <th>Searchable</th>
              <th>Item ID</th>
              <th>Created at</th>
              <th>Updated at</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in items" :key="item.id">
              <td>{{ item.id }}</td>
              <td>{{ getAccountName(item) }}</td>
              <td>{{ item.kind }}</td>
              <td>{{ item.version }}</td>
              <td>{{ item.searchable }}</td>
              <td v-if="item.itemId" class="nowrap"> <router-link :to="`/admin/items/${item.item_id}`">
                  Parent ID: {{ item.itemId }}</router-link>
              </td>
              <td v-else> - </td>
              <td>{{ item.createdAt | datetime }}</td>
              <td>{{ item.updatedAt | datetime }}</td>
              <td>
                <router-link :to="buildLink(item)" class="btn btn-primary">
                  Ver
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-md-12 my-1">
        <Pagination v-model="meta.currentPage" :total-count="meta.totalCount" :total-pages="meta.totalPages"
          @pagination="pagination" />
      </div>
    </div>
  </div>
</template>

<script>
import BadgeFilters from '@/components/shares/BadgeFilters'
import ModelMapper from '@/mixins/ModelMapper'
import handleSearchable from '@/models/handleSearchable'
import GetUser from '@/mixins/GetUser'

import Pagination from '@/components/shares/specialTag/Pagination'
import Select2 from '@/components/shares/Select2'

import { Filter } from '@/models/filter'
import { ChevronDownIcon, SearchIcon } from 'vue-feather-icons'

export default {
  components: { BadgeFilters, ChevronDownIcon, Pagination, SearchIcon, Select2 },
  computed: {
    currentAxios() {
      return this.axios.v3
    },
    items() {
      return this.getModels || []
    },
    badgeFilters() {
      return [
        this.filterKind,
        this.filterAccount,
        this.filterEndDate,
        this.filterStartDate
      ]
    }
  },
  created() {
    this.$set(this.query, 'periodType', 'created_at')
    this.defaultModelSetting.updateQueryURL = true
    this.asyncTemplateSelect({
      byURL: true,
      pagination: true,
      after: () => this.mountFilters()
    })
    this.filterAccount = this.buildFilterAccount(this.allAccounts.data)
  },
  data: () => ({
    filterKind: null,
    filterAccount: null,
    filterEndDate: new Filter({
      key: 'endDate',
      label: 'Data final',
      type: 'date'
    }),
    filterStartDate: new Filter({
      key: 'startDate',
      label: 'Data inicial',
      type: 'date'
    }),
    modelPathPrefix: 'admin',
    nameModel: 'Item',
    orderBy: 'created_at',
  }),
  inject: ['allAccounts', 'buildFilterAccount', 'getAccountName'],
  methods: {
    buildParams(pagination) {
      if (this.query.generic)
        this.query.generic = handleSearchable(this.query.generic)

      return ModelMapper.methods.buildParams.call(this, pagination)
    },
    buildLink(item) {
      return `/admin/items/${item.id}?kind=${item.kind}`
    },
    find() {
      this.asyncTemplateSelect()
    },
    mountFilters() {
      const key = 'admin/items/fetch_columns'
      const mount = (data) => {
        this.filterKind = new Filter({ key: 'kind', label: 'Kind', table: data['kind'] })
      }

      const data = this.$ls.get(key)
      if (data)
        return mount(data)

      this.currentAxios.get(key)
        .then(response => {
          mount(response.data)
          this.$ls.set(key, data, { minutes: 5 })
        })
    }
  },
  mixins: [ModelMapper, GetUser],
  name: 'AdminItemsIndex',
  watch: {
    orderBy(newValue, oldValue) {
      if (newValue === oldValue) return

      this.order = []
      this.addOrderBy(newValue, 'desc')
      this.find()
    }
  },
}
</script>
